// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"517":"819ea4e7","695":"8f23fc99"}[chunkId] + ".chunk.css";
};